import dayjs from 'dayjs';
import flatpickr from 'flatpickr'; // flatpickr is a global export - check rollupjs.config for details
import { getNumberOfNight } from './../util.js';

export function Flatpickr(node, opts) {
  const fp = flatpickr(node, opts.calendarConfig);

  const setTotalNights = (numberOfNight) => {
    // Bail early when number is not exist
    if (!numberOfNight || numberOfNight === 0) {
      return;
    }
    // Check small screen size
    const isLargeScreen = window.matchMedia('(min-width: 768px)').matches;
    const isNightsOrNight = numberOfNight > 1 ? ' nights' : ' night';
    const showNight = isLargeScreen ? isNightsOrNight : '';
    return `(${numberOfNight}${showNight})`;
  };

  return {
    update(opts) {
      const datesSelected = opts.value.length === 2;
      if (datesSelected) {
        const [firstSelectedDate, secondSelectedDate] = opts.value;
        fp.setDate([firstSelectedDate, secondSelectedDate]);
        //fp.input.value = `${fp.input.value} ${setTotalNights(getNumberOfNight(dayjs(firstSelectedDate), dayjs(secondSelectedDate)))}`;
        fp.input.value = `${dayjs(firstSelectedDate).format('D MMM YY')} to ${dayjs(secondSelectedDate).format('D MMM YY')} ${setTotalNights(getNumberOfNight(dayjs(firstSelectedDate), dayjs(secondSelectedDate)))}`;
      } 
      else if(opts.value.length==1){
        //fp.setDate(opts.value);
        fp.input.value = dayjs(opts.value).format('D MMM YY');
      }
      else {
        fp.clear();
      }
    },
  };
}
